import { render } from "./MemberRegistrationForm.vue?vue&type=template&id=7c56f404"
import script from "./MemberRegistrationForm.vue?vue&type=script&lang=js"
export * from "./MemberRegistrationForm.vue?vue&type=script&lang=js"

import "./MemberRegistrationForm.vue?vue&type=style&index=0&id=7c56f404&lang=css"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__